<script setup lang="ts">
import {computed} from "vue";

const props = defineProps(['message'])
const createdAt = new Date(props.message.created_at);

const isToday = computed(() => {
    const now = new Date();
    return createdAt.getDate() === now.getDate() && createdAt.getMonth() === now.getMonth() && createdAt.getFullYear() === now.getFullYear()
})
const formatDate = computed(() => {
    return createdAt.toLocaleString('pt-BR',  {day: '2-digit', month: '2-digit', year: 'numeric'});
})
</script>
<template>
    <div class="w-full my-7 flex items-center justify-center">
        <div
            class="w-full h-0 border-t border-dashed dark:border-gray-600 dark:bg-white/0"
        ></div>
        <p class="body-4 text-black/70 dark:text-white/70 mx-5">{{isToday ? 'Hoje' : formatDate}}</p>
        <div
            class="w-full h-0 border-t border-dashed dark:border-gray-600 dark:bg-white/0"
        ></div>
    </div>
</template>
